import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface CandidatoCvDTO {
  id: number;
  label: string;
  fileName: string;
  fileSize: number;
  isActive: boolean;
  createdAt: string;
  downloadUrl: string;
}

@Injectable({ providedIn: 'root' })
export class CandidatoCvService {

  private base = `${environment.baseApi}/privado/cv`;

  constructor(private http: HttpClient) {}

  list(candidatoId: number): Observable<any> {
    return this.http.get(`${this.base}/list/${candidatoId}`);
  }

  upload(candidatoId: number, file: File, label: string): Observable<any> {
    const form = new FormData();
    form.append('file', file);
    form.append('label', label);
    return this.http.post(`${this.base}/upload/${candidatoId}`, form);
  }

  activate(candidatoId: number, cvId: number): Observable<any> {
    return this.http.put(`${this.base}/activate/${candidatoId}/${cvId}`, {});
  }

  delete(candidatoId: number, cvId: number): Observable<any> {
    return this.http.delete(`${this.base}/${candidatoId}/${cvId}`);
  }

  /** Descarga el PDF con el JWT del interceptor y retorna un Blob */
  download(candidatoId: number, cvId: number): Observable<Blob> {
    return this.http.get(`${this.base}/download/${candidatoId}/${cvId}`, {
      responseType: 'blob'
    });
  }

  formatSize(bytes: number): string {
    if (!bytes) return '—';
    if (bytes < 1024) return `${bytes} B`;
    if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
    return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
  }
}
